export enum ApplicationStage {
  DEFAULT = "DEFAULT",
  LOCAL = "LOCAL",
  DEVELOPMENT = "DEVELOPMENT",
  PRODUCTION = "PRODUCTION",
}

export type IAppConfigs = Record<ApplicationStage, IAppConfig>;

export interface IAppConfig {
  environment: ApplicationStage;
  api: {
    url: string;
  };
  resetApi: {
    url: string;
  };
}
